const appliance = ['APPLIANCE', 'RACK'];
const computer = ['MINI_PC', 'DESKTOP', 'TOWER', 'RACK'];
export const deviceClassificationRules = {
    UNKNOWN: { category: 'OTHER', virtual: true, forms: [...computer, 'APPLIANCE'], host: false },
    OTHER: { category: 'OTHER', virtual: true, forms: [...computer, 'APPLIANCE'], host: false },
    FIREWALL: { category: 'NETWORK', virtual: true, forms: appliance, host: false },
    ROUTER: { category: 'NETWORK', virtual: true, forms: appliance, host: false },
    SWITCH: { category: 'NETWORK', virtual: true, forms: appliance, host: false },
    ACCESS_POINT: { category: 'NETWORK', virtual: false, forms: [], host: false },
    NETWORK_CONTROLLER: {
        category: 'NETWORK',
        virtual: true,
        forms: ['APPLIANCE', 'MINI_PC', 'RACK'],
        host: false,
    },
    UPS: { category: 'OTHER', virtual: false, forms: ['APPLIANCE', 'TOWER', 'RACK'], host: false },
    NAS: { category: 'OTHER', virtual: true, forms: [...computer, 'APPLIANCE'], host: true },
    PBX: { category: 'OTHER', virtual: true, forms: [...computer, 'APPLIANCE'], host: false },
    NOTEBOOK: { category: 'CLIENT', virtual: false, forms: [], host: false },
    WORKSTATION: {
        category: 'CLIENT',
        virtual: true,
        forms: ['MINI_PC', 'DESKTOP', 'TOWER'],
        host: true,
    },
    SERVER: { category: 'SERVER', virtual: true, forms: computer, host: true },
    MOBILE: { category: 'MOBILE', virtual: false, forms: [], host: false },
    PRINTER: { category: 'PRINTER', virtual: false, forms: [], host: false },
};
export function deviceClassificationOptions(deviceType, execution) {
    const rule = deviceClassificationRules[deviceType];
    return {
        executions: (rule.virtual
            ? ['UNKNOWN', 'PHYSICAL', 'VIRTUAL']
            : ['PHYSICAL']),
        hostings: ((execution === 'PHYSICAL' && deviceType !== 'SERVER') || !rule.virtual
            ? ['UNKNOWN', 'ON_PREMISES', 'HOSTED']
            : ['UNKNOWN', 'ON_PREMISES', 'CLOUD', 'HOSTED']),
        forms: [
            'UNKNOWN',
            ...(execution === 'PHYSICAL' ? rule.forms : []),
        ],
        host: rule.host && execution === 'PHYSICAL',
    };
}
/** Presentation changes are explicit; API writes reject conflicting supplied values. */
export function normalizeDeviceClassification(input) {
    const rule = deviceClassificationRules[input.deviceType];
    const execution = !rule.virtual ? 'PHYSICAL' : input.execution;
    const options = deviceClassificationOptions(input.deviceType, execution);
    const hosting = options.hostings.includes(input.hosting) ? input.hosting : 'UNKNOWN';
    return {
        ...input,
        execution,
        hosting,
        formFactor: options.forms.includes(input.formFactor) ? input.formFactor : 'UNKNOWN',
        roles: options.host ? input.roles : [],
        hostingProvider: hosting === 'CLOUD' || hosting === 'HOSTED' ? input.hostingProvider : null,
        hostingRegion: hosting === 'CLOUD' || hosting === 'HOSTED' ? input.hostingRegion : null,
    };
}
export function deviceClassificationErrors(input) {
    const options = deviceClassificationOptions(input.deviceType, input.execution);
    const errors = [];
    // UNKNOWN execution remains valid for unclassified historical records.
    if (input.execution !== 'UNKNOWN' && !options.executions.includes(input.execution))
        errors.push('Dieser Gerätetyp kann nicht virtuell betrieben werden.');
    if (!options.hostings.includes(input.hosting))
        errors.push('Dieser Gerätetyp benötigt OnPrem oder ein externes Rechenzentrum als Betriebsort. Physische Cloud-Server werden als Server erfasst.');
    if (!options.forms.includes(input.formFactor))
        errors.push('Die Bauform passt nicht zu Gerätetyp und Ausführung.');
    if (input.roles.length && !options.host)
        errors.push('Die Host-Rolle erfordert einen physischen Server, eine Workstation oder ein NAS.');
    if (input.hosting !== 'CLOUD' &&
        input.hosting !== 'HOSTED' &&
        (input.hostingProvider || input.hostingRegion))
        errors.push('Anbieter und Rechenzentrum erfordern Cloud oder externes Hosting.');
    return errors;
}
//# sourceMappingURL=device-classification.js.map